// extracted by mini-css-extract-plugin
export default {"wrapper":"sQ-z","availablePromoMessagesLabel":"tQ-z","promoMessageList":"uQ-z","promoMessage":"vQ-z","appliedPromoMessage":"wQ-z","promoMessageAmount":"xQ-z"};